import {useTranslation} from "react-i18next";
import {getCurrentLang} from "../utils/lang";
import {Lang} from "../types";
import React from "react";
import {Space} from "antd";
import {AmplitudeEvent, logEvent} from "../utils/amplitude";

interface Props {
    className?: string;
}

const LanguageSelector = ({className}:Props) => {
    const { i18n } = useTranslation();

    const activeStored: Lang = getCurrentLang();
    const changeLang = (lang: string) => (): void => {
        logEvent(AmplitudeEvent.LANGUAGE_CHANGE, {lang});
        i18n.changeLanguage(lang);
    };

    const activeColor = "text-white";
    const passiveColor = "text-[#6C757D]";
    const enClass = activeStored === Lang.EN ? activeColor : passiveColor;
    const ruClass = activeStored === Lang.RU ? activeColor : passiveColor;

    return (
        <Space className={`language-selection ${className}`} size="small" align="center">
            <button key="en" className={enClass} onClick={changeLang(Lang.EN)}>En</button>
            <button key="ru" className={ruClass} onClick={changeLang(Lang.RU)}>Ru</button>
        </Space>
    );
};

export default LanguageSelector;
